import { userConstants } from "../constants/login.constants";

 function didUpdate(state = {}, action) {
    switch (action.type) {
        case userConstants.INDIVDUALENTITIESDID_REQUEST:
            return {
                loading: true
            };
        case userConstants.INDIVDUALENTITIESDID_SUCCESS:
            return {
                items: action.didUpdate
            };
        case userConstants.INDIVDUALENTITIESDID_FAILURE:
            return {
                error: action.errorDidUpdate
                
            };
        default:
            return state
    }
}
export default didUpdate;